var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { mergeProps, useFocusRing } from 'react-aria';
import { CardProvider } from './card-context';
import { cardStyle, decorStyle, headstoneStaticStyle } from './styles';
function CardInternal(_a, ref) {
    var { as, children, disableHoverEffect = false, headstone, highlightPlacement = 'left', highlightVariant = 'green', inverted = false, size = 'medium', variant = 'regular' } = _a, restProps = __rest(_a, ["as", "children", "disableHoverEffect", "headstone", "highlightPlacement", "highlightVariant", "inverted", "size", "variant"]);
    const Element = as !== null && as !== void 0 ? as : 'section';
    const { focusProps, isFocusVisible } = useFocusRing();
    const typedRestProps = restProps;
    const hasHeadstone = headstone != null;
    return (_jsx(CardProvider, Object.assign({ size: size }, { children: _jsxs(Element, Object.assign({ css: cardStyle({
                disableHoverEffect,
                hasHeadstone,
                inverted,
                isFocusVisible,
            }), ref: ref }, mergeProps(focusProps, typedRestProps), { children: [hasHeadstone && _jsx("div", Object.assign({ css: headstoneStaticStyle }, { children: headstone })), variant === 'highlight' && (_jsx("div", { css: decorStyle({ highlightPlacement, highlightVariant }) })), children] })) })));
}
export default CardInternal;
